import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { ShimmerTable, ShimmerTitle, ShimmerCircularImage } from "react-shimmer-effects";



const MaturityLevelAverageScores = () => {

    const [onLoading, setOnLoading] = useState(false)

    const [parentWidth, setParentWidth] = useState(0);
    const [screenWidth, setScreenWidth] = useState(1000);

    useEffect(() => {
        setScreenWidth (window.innerWidth - ((window.innerWidth * 25)/100))
    }, []);

    useEffect(() => {
      const updateParentWidth = () => {
        const parentDiv = document.getElementById('parentDiv');
        if (parentDiv) {
          const width = parentDiv.offsetWidth;
          setParentWidth(width * 0.95); // Assigning 90% width
        }
      };
  
      updateParentWidth();
  
      window.addEventListener('resize', updateParentWidth);
  
      return () => {
        window.removeEventListener('resize', updateParentWidth);
      };
    }, []);

    const options = {
        chart: {
          type: 'bar',
          height: 350,
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: ['All Policies Defined', 
          'Controls 1-6 Implemented', 
          'All Controls Implemented', 
          'All Controls Automated',
          'All Controls Reported',
          'Maturity Rating'
          ],
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 5
        },
        series: [{
          name: 'Group Implementation Averages',
          data: [40, 60, 80,40, 60, 80]
        }],
        legend: {
          offsetY: -10,
        }
      };
   
   
   

    return (
        <div style={{
            width: '57%', marginLeft: 0, display: 'flex', flexDirection: 'column', 
            height: 450,
            marginTop: '2%', background: 'linear-gradient(135deg, #161c2a, #1a2130)', padding: 20, borderRadius: 15
        }}>



            {onLoading &&

                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 100 }}>

                    <ShimmerCircularImage size={500} />
                    <ShimmerCircularImage size={500} />
                </div>
            }


            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 10 }}>


                <div style={{ width: '100%' }}>

                    <h6 style={{ color: '#fff', textAlign: 'left' }}>
                        Maturity Level Average Scores</h6>
                    <hr />


                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} id="parentDiv">
                         
       
                    <ReactApexChart options={options} 
                        series={options.series} type="bar" height={350} 
                        width={screenWidth * 0.6} />
                    

                    </div>
                </div>
            </div>


        </div>
    );
};

export default MaturityLevelAverageScores;